"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unique = exports.filter = void 0;
var constants_1 = require("../constants");
var inPropsOrState = function (_a) {
    var props = _a.props, state = _a.state;
    return function (v) { return props[v] || state[v]; };
};
var filter = function (modifiers) {
    return modifiers.filter(function (m) { return m != null; });
};
exports.filter = filter;
var unique = function () {
    var modifiers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        modifiers[_i] = arguments[_i];
    }
    return Array.from(new Set(modifiers.reduce(function (next, current) { return __spreadArray(__spreadArray([], next), current); })));
};
exports.unique = unique;
var processModifiers = function (modifiersCallback, parameters) {
    var modifiers = [];
    var result = modifiersCallback(parameters);
    if (result) {
        var exists = inPropsOrState(parameters);
        for (var k in result) {
            var v = result[k];
            if (v === true && exists(k)) {
                modifiers.push(k);
            }
            else if (typeof v === 'function') {
                var modifier = v(parameters);
                if (modifier) {
                    modifiers.push(typeof modifier === 'string' ? modifier : k);
                }
            }
            else if (v === constants_1.USE_VALUE) {
                var prop = exists(k);
                if (prop)
                    modifiers.push(String(prop));
            }
        }
    }
    return modifiers;
};
exports.default = processModifiers;
//# sourceMappingURL=processModifiers.js.map